module.exports = __webpack_public_path__ + "static/media/OfficinaSansITCPro-Bold.645127a5.eot";